// extracted by mini-css-extract-plugin
export default {"container":"FormLoadingScreen_container__t8Fzf","hasTitle":"FormLoadingScreen_hasTitle__9BcLh"};